import { CancelOrEndTowingRecordFormValues } from '../types'
import { CancelTowingRecordMutationVariables } from './types'
import { toALScalarTimestamp } from '../../routes/subforms/ArrivalRoute/mutation/toMutationVariables'

export function toCancelMutationVariables(values: CancelOrEndTowingRecordFormValues): CancelTowingRecordMutationVariables {
  return {
    input: {
      id: values.towingRecordId,
      cancelReason: values.cancelReason,
      withFee: values.withFee,
      cancelledLocation: values.cancelLocation?.address
        ? {
            address: values.cancelLocation.address,
            city: values.cancelLocation.city,
            zipcode: values.cancelLocation.zipcode,
            coords: values.cancelLocation.coords,
          }
        : null,
      jobEndedAt: values.jobEndedAt ? toALScalarTimestamp(values.jobEndedAt) : null,
    },
  }
}
